import { Container, TextField } from '@mui/material';
import Grid from '@mui/material/Grid2';
import * as Yup from 'yup';
import InfoBox from '../ui/DaliaComponents';
import WizardStep from '../ui/WizardStep';
import './PatientInitWizardStep.css';

const PatientInitStepPatientInfo: WizardStep = ({ formik }) => {
  return (
    <Container className="mt-5 container-wizard">
      <Grid container spacing={2}>
        <Grid size={12}>
          <InfoBox emoji="🙏">Merci d'avoir validé que le patient remplissait les critères d'inclusion et d'exclusion</InfoBox>
        </Grid>

        <Grid size={3}>Mois et année de naissance du patient (code d&apos;activation)</Grid>
        <Grid size={9}>
          <TextField
            error={formik.touched.code && Boolean(formik.errors.code)}
            helperText={formik.touched.code && formik.errors.code}
            id="dateOfBirthT"
            name="code"
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            placeholder="MMAA"
            required
            style={{ width: '100%', textAlign: 'center' }}
            type="text"
            value={formik.values.code}
          />
        </Grid>
        <Grid size={3}>Numero de portable du patient</Grid>
        <Grid size={9}>
          <TextField
            error={formik.touched.phone && Boolean(formik.errors.phone)}
            helperText={formik.touched.phone && formik.errors.phone}
            id="phone"
            name="phone"
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            placeholder="Numéro de téléphone"
            required
            style={{ width: '100%', textAlign: 'center' }}
            type="text"
            value={formik.values.phone}
          />
        </Grid>
        <Grid size={3}>Code externe du patient (optionnel)</Grid>
        <Grid size={9}>
          <TextField
            error={formik.touched.externalId && Boolean(formik.errors.externalId)}
            helperText={formik.touched.externalId && formik.errors.externalId}
            id="externalId"
            name="externalId"
            onBlur={formik.handleBlur}
            onChange={formik.handleChange}
            placeholder="Initiales"
            style={{ width: '100%', textAlign: 'center' }}
            type="text"
            value={formik.values.externalId}
          />
        </Grid>
      </Grid>
    </Container>
  );
};
PatientInitStepPatientInfo.label = "Code d'activation";

PatientInitStepPatientInfo.initialValues = {
  code: '',
  phone: '',
  externalId: '',
};

PatientInitStepPatientInfo.validationSchema = () => {
  return Yup.object({
    code: Yup.string()
      .matches(/^(0[1-9]|1[0-2])([0-9]{2})$/, 'La date de naissance doit être au format MMYY.')
      .required('Ce champ est requis'),
    phone: Yup.string()
      .matches(/^(\+33|0)[1-9](\d{2}){4}$/, 'Numéro de téléphone invalide')
      .required('Le numéro de téléphone est requis'),
  });
};

export default PatientInitStepPatientInfo;